import React, { lazy, Suspense, useEffect } from 'react';
import { Route, Routes } from 'react-router-dom';
import { Layout } from '../components/layout/Layout';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useActions } from '../hooks/useAction';
import { NotFoundPage } from '../pages/not-found/NotFoundPage';
import { getUserId, getUserToken, userIsStorage } from '../modules/Login/helpers/storage';
import { useTypedSelector } from '../hooks/useTypesSelector';
import { Loading } from '../ui/loading/Loading';

const MainPage = lazy(() => import('../pages/main/MainPage'));
const LoginPage = lazy(() => import('../pages/login/LoginPage'));
const RegisterPage = lazy(() => import('../pages/login/RegisterPage'));
const BookPage = lazy(() => import('../pages/book/BookPage'));
const MiniGamePage = lazy(() => import('../pages/mini-game/MiniGamePage'));
const StatisticsPage = lazy(() => import('../pages/statistics/StatisticsPage'));
const AudioPage = lazy(() => import('../pages/mini-game/audio/Audio'));
const SprintPage = lazy(() => import('../pages/mini-game/sprint/Sprint'));

function App() {
  const { userId } = useTypedSelector((state) => state.auth.user);
  const { fetchGetUser } = useActions();

  useEffect(() => {
    if (userIsStorage() && !userId) {
      fetchGetUser(getUserId(), getUserToken());
    }
  }, [fetchGetUser, userId]);

  return (
    <>
      <Suspense fallback={<Loading />}>
        <div className="page">
          <ToastContainer autoClose={5000} />
          <Routes>
            <Route path="/" element={<Layout />}>
              <Route path="*" element={<NotFoundPage />} />
              <Route index element={<MainPage />} />
              <Route path="login" element={<LoginPage />} />
              <Route path="registration" element={<RegisterPage />} />
              <Route path="book" element={<BookPage />} />
              <Route path="book/group:group/page:page" element={<BookPage key={Date.now()} />} />
              <Route path="game" element={<MiniGamePage />} />
              <Route path="game/audio" element={<AudioPage />} />
              <Route path="game/sprint" element={<SprintPage />} />
              <Route path="statistic" element={<StatisticsPage />} />
            </Route>
          </Routes>
        </div>
      </Suspense>
    </>
  );
}

export default App;
